import React from 'react';

export interface IToasterContext {
  addToast: (toast: any) => void;
}

export const ToasterContext = React.createContext<IToasterContext>({
  addToast: () => {},
});
